function openSizeModal(modalId) {
  const modal = document.getElementById(modalId);
  const overlay = document.getElementById("overlay-" + modalId.split("-")[1]);
  modal.classList.add("active");
  overlay.classList.add("active");
}

function closeSizeModal(modalId) {
  const modal = document.getElementById(modalId);
  const overlay = document.getElementById("overlay-" + modalId.split("-")[1]);
  modal.classList.remove("active");
  overlay.classList.remove("active");
}

document.querySelectorAll("[data-modal-open]").forEach((btn) => {
  btn.addEventListener("click", function () {
    const modalId = this.getAttribute("data-modal-open");
    openSizeModal(modalId);
  });
});

document.querySelectorAll(".btn-close").forEach((btn) => {
  btn.addEventListener("click", function () {
    const modalId = this.getAttribute("data-modal");
    closeSizeModal(modalId);
  });
});

document.querySelectorAll(".overlay").forEach((overlay) => {
  overlay.addEventListener("click", function () {
    const modalId = this.id.replace("overlay-", "modal-");
    closeSizeModal(modalId);
  });
});
